<form [formGroup]="contactForm" (ngSubmit)="onSubmit()">

  <ms-input-label [labelText]="'Name'" [isRequired]="isFieldRequired(contactForm, 'name')" />
  <input type="text" id="contact-name" formControlName="name" maxlength="100"
    [required]="isFieldRequired(contactForm, 'name')"
    class="form-control"
    [class.is-invalid]="contactForm.get('name')?.invalid && contactForm.get('name')?.touched"
    [class.is-valid]="contactForm.get('name')?.valid && contactForm.get('name')?.touched && contactForm.get('name')?.value !== ''" />
  @if (contactForm.get('name')?.invalid && contactForm.get('name')?.touched) {
    <div class="error-messages">
      @if (contactForm.get('name')?.errors?.['required']) {
        <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.OrganizationContactNameRequired }}</p>
      }
    </div>
  }

  <ms-input-label [labelText]="'Email Address'" class="mt-3" />
  <ms-email-input formControlName="email" />

  <ms-input-label [labelText]="'Phone Number'" class="mt-3" />
  <ms-phone-input id="contact-phone" formControlName="telephone" />

  <div class="d-flex justify-content-between align-items-center mt-4">
    <button type="button" class="btn btn-ms-secondary" (click)="onBack()">
      <fa-duotone-icon icon="chevron-left" secondaryOpacity="0.9" class="me-1"></fa-duotone-icon>
      Back
    </button>
    <div class="d-flex">
      <button type="button" class="btn btn-ms-secondary me-3" (click)="onCancel()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
        @if (isSubmitting) {
          <div class="spinner-border text-light spinner-border-sm" role="status">
            <span class="visually-hidden">Saving...</span>
          </div>
        } @else {
          Save
        }
      </button>
    </div>
  </div>
</form>
